export const environment = {
  production: true,
  //apiURL: 'http://localhost/safarizine-admin/public/',
  apiURL: 'https://backend.safarizine.com/',
  apiClientId: 'safarizine-app',
  apiClientSecret: 'ff5ecf716dda30f5d56a6adada34d5b8c1ebc8e1bfc979c5fd654b94ce9aeeb6',
  firebase: {}
};
